export default __webpack_public_path__ + "static/media/3.82b9b52f.mp3";